/**
 * @see https://github.com/prismicio/gatsby/blob/v3.3.6/docs/previews-api.md#using-locally-transformed-images
 */
export const makeImagePreviewable = (image) => {
  if (!image) {
    return undefined;
  }

  if (image.localFile) {
    return image;
  }

  const imageContent = {
    ...image,
    ...((image.fluid || image.fixed || image.url) && {
      localFile: {
        childImageSharp: {
          fluid: image.fluid,
          fixed: image.fixed,
        },
        url: image.url,
        id: image.fluid?.src || image.url,
      }
    })
  }

  return imageContent;
}